import { Outlet, type RouteObject } from 'react-router-dom';
import { RequireAuth } from '@/auth/RequireAuth';
import type { RouteHandle } from '@/layout/routeHandle';
import { FORM_CONFIGS, type FormTypeConfig } from './config';
import { SnapshotDetailPage } from './SnapshotDetailPage';
import { SnapshotListPage } from './SnapshotListPage';

/**
 * forms（担当: G4）。帳票スナップショット（各種様式）の作成・一覧・詳細。
 *   forms/roster              S-14・S-15 参加船名簿（R-01）               全ロール（庁県は参照・出力）
 *   forms/monitoring-report-1 S-70 実績報告書①（R-05・R-06）            全ロール（庁県は参照・出力）
 *   forms/monitoring-report-2 S-63 実績報告書②（R-07）                  全ロール（庁県は参照・出力）
 *   forms/monitoring-report-3 S-64 実績報告書③（R-08）                  基金・漁協
 *   forms/dispatch-plan       S-71 調査船出動計画表（R-16）             基金・漁協
 */
const shortTitle: Record<string, string> = {
  roster: '参加船名簿',
  monitoring1: '監視実績報告書1',
  monitoring2: '監視実績報告書2',
  monitoring3: '監視実績報告書3',
  dispatch: '調査船出動計画表',
};

function route(key: string, config: FormTypeConfig): RouteObject {
  return {
    path: config.path,
    handle: { crumb: shortTitle[key] ?? config.title } satisfies RouteHandle,
    element: (
      <RequireAuth roles={config.viewRoles}>
        <Outlet />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <SnapshotListPage key={key} config={config} /> },
      { path: ':id', element: <SnapshotDetailPage key={key} config={config} />, handle: { crumb: '詳細' } satisfies RouteHandle },
    ],
  };
}

export const routes: RouteObject[] = Object.entries(FORM_CONFIGS).map(([key, config]) => route(key, config));
